import {
  FETCH_USER_REPORTS,
  FETCH_USER_REPORTS_SUCCESS,
  FETCH_USER_REPORTS_FAILED,
  SUBMIT_USER_REPORT,
  UPDATE_USER_REPORT,
} from '../store/types';
import { firebase } from '../config/configureFirebase';
import store from '../store/store';
import { onValue, push, set, off } from 'firebase/database';

export const fetchUserReports = () => (dispatch) => {
  const { userReportsRef, userReportsListRef } = firebase;
  const profile = store.getState().auth.profile;
  const isAdmin = profile && profile.usertype === 'admin';
  const listRef = isAdmin
    ? userReportsRef
    : (profile && profile.uid ? userReportsListRef(profile.uid) : userReportsRef);

  dispatch({ type: FETCH_USER_REPORTS, payload: null });

  off(listRef);
  onValue(listRef, (snapshot) => {
    if (snapshot.val()) {
      const data = snapshot.val();
      const arr = Object.keys(data).map((key) => ({ ...data[key], id: key }));
      dispatch({
        type: FETCH_USER_REPORTS_SUCCESS,
        payload: arr.sort((a, b) => (b.createdAt || 0) - (a.createdAt || 0)),
      });
    } else {
      dispatch({
        type: FETCH_USER_REPORTS_SUCCESS,
        payload: [],
      });
    }
  });
};

export const submitUserReport = (report) => (dispatch) => {
  const { userReportsRef } = firebase;
  const profile = store.getState().auth.profile;
  if (!profile?.uid || !report?.reportedUid) {
    return Promise.resolve(false);
  }

  const payload = {
    reporterUid: profile.uid,
    reporterName: `${profile.firstName || ''} ${profile.lastName || ''}`.trim(),
    reporterRole: profile.usertype || '',
    reportedUid: report.reportedUid,
    reportedName: report.reportedName || '',
    reportedRole: report.reportedRole || '',
    bookingId: report.bookingId || '',
    messageSnippet: report.messageSnippet || '',
    reason: report.reason || 'other',
    details: report.details || '',
    context: report.context || 'trip',
    createdAt: Date.now(),
    status: 'pending',
    check: false,
  };

  dispatch({ type: SUBMIT_USER_REPORT, payload });
  return push(userReportsRef, payload);
};

export const updateUserReport = (report) => (dispatch) => {
  const { editUserReportRef } = firebase;
  if (!report?.id) return;
  dispatch({ type: UPDATE_USER_REPORT, payload: report });
  set(editUserReportRef(report.id), {
    ...report,
    processDate: report.processDate || Date.now(),
  });
};
